import { ROUTE_SEGMENTS } from "@/constants/navigation";

export const CONSOLE_SHELL_ROUTE_RELATIVE_PATHS = {
  EXECUTIVE_SUMMARY: ROUTE_SEGMENTS.EXECUTIVE_SUMMARY,
  CHANNEL_DETAIL: ROUTE_SEGMENTS.CHANNEL_DETAIL,
  SPARX_CATALOG: ROUTE_SEGMENTS.SPARX_CATALOG,
  SPARXS_EDITOR: `${ROUTE_SEGMENTS.SPARXS_EDITOR}/:id?/:panel?`,
  SVG_ALTERATION: ROUTE_SEGMENTS.SVG_ALTERATION,
} as const;
